"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHifiLandingViewNonAuth = void 0;
/**
 * A builder for HifiLandingViewNonAuth
 *
 * @param data - The event data
 * @return The formatted event data for HifiLandingViewNonAuthEvent
 */
function createHifiLandingViewNonAuth(data) {
    return {
        name: 'HifiLandingViewNonAuth',
        environments: ['browsernonauth'],
        data: data,
    };
}
exports.createHifiLandingViewNonAuth = createHifiLandingViewNonAuth;
//# sourceMappingURL=createHifiLandingViewNonAuth.js.map